import React, { useEffect, useRef } from "react";
import initialization from "./initialization";
import PropTypes from "prop-types";
import { self } from "@default/js/config";

const MorphSlider = ({ content, id, isMobile }) => {
  const morphSlider = useRef();

  let images = content;
  /*let images = [];
  images.push(
    `${self}/glitch-test/glitch-test-1.jpg`,
    `${self}/glitch-test/glitch-test-2.jpg`,
    `${self}/glitch-test/glitch-test-3.jpg`
  );*/

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!images.length) return;
    if (!morphSlider.current) return;

    // Prevent re-initialization
    const hasCanvas = morphSlider.current.querySelector("canvas");
    if (hasCanvas) return;

    initialization(morphSlider.current, id, isMobile);
  }, [id, isMobile, images]);

  return (
    <div className="morph-slider" ref={morphSlider}>
      {content && images && (
        <div
          id={id}
          data-images={JSON.stringify(images)}
          data-displacement=""
          className="canvas-wrapper"
        />
      )}
    </div>
  );
};

MorphSlider.propTypes = {
  content: PropTypes.array,
  id: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default MorphSlider;
